export const ChevronDown = () => {
  return (
    <svg viewBox="-1 -1 24 24" height="24" width="24" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.3125 6.70175 11.485833333333332 16.5275c-0.0638 0.06389166666666667 -0.13951666666666665 0.11449166666666666 -0.22284166666666666 0.14905 -0.08341666666666667 0.03465 -0.17279166666666665 0.05243333333333333 -0.2629916666666666 0.05243333333333333 -0.0902 0 -0.17957499999999998 -0.01778333333333333 -0.2629916666666666 -0.05243333333333333 -0.083325 -0.03455833333333333 -0.15904166666666664 -0.08515833333333332 -0.22284166666666666 -0.14905L0.6875 6.70175"
        strokeWidth="2"
      ></path>
    </svg>
  );
};
